import React, { useState } from "react"
import propTypes from "prop-types"
import { Badge, Button, Tooltip } from "reactstrap"

import { isMainProductPresentation } from "./presentationHelpers"

const PresentationItemList = ({ item, product, canDelete, canEdit, openEditModal, openDeleteModal, openConvertModal }) => {
  const isMainPresentation = isMainProductPresentation(item, product)
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const mainPresentationTooltipId = `main-presentation-${item.id}`

  const renderEditButton = () => {
    if (!canEdit || isMainPresentation) {
      return null
    }

    return (
      <Button color="primary" className="m-1" onClick={() => openEditModal(item.id)}>
        <i className="fa fa-edit" />
      </Button>
    )
  }

  const renderDeleteButton = () => {
    if (!canDelete || isMainPresentation) {
      return null
    }

    return (
      <Button color="danger" onClick={() => openDeleteModal(item)} title="Desactivar presentacion">
        <i className="fa fa-trash" />
      </Button>
    )
  }

  const renderConvertButton = () => {
    if (!canEdit || isMainPresentation) {
      return null
    }

    return (
      <Button color="warning" className="m-1" onClick={() => openConvertModal(item)} title="Convertir en producto">
        <i className="fa fa-exchange-alt" />
      </Button>
    )
  }

  return (
    <tr key={item.id}>
      <td>{item.key}</td>
      <td>
        {item.description}
        {isMainPresentation && (
          <>
            <Badge color="secondary" className="ms-2" id={mainPresentationTooltipId}>
              Principal
            </Badge>
            <Tooltip
              placement="top"
              isOpen={tooltipOpen}
              target={mainPresentationTooltipId}
              toggle={() => setTooltipOpen(!tooltipOpen)}
            >
              Es la presentacion principal del producto. Para eliminarla, debes desactivar el producto actual.
            </Tooltip>
          </>
        )}
      </td>
      <td>{item.presentation_unit}</td>
      <td className="text-center">
        {isMainPresentation ? "No editable" : (
          <>
            {renderEditButton()}
            {renderConvertButton()}
            {renderDeleteButton()}
          </>
        )}
      </td>
    </tr>
  )
}

PresentationItemList.propTypes = {
  item: propTypes.object,
  product: propTypes.object,
  canDelete: propTypes.bool,
  canEdit: propTypes.bool,
  openEditModal: propTypes.func,
  openDeleteModal: propTypes.func,
  openConvertModal: propTypes.func,
}

export default PresentationItemList
